import { render, staticRenderFns } from "./AccountMoneyClaim.vue?vue&type=template&id=284a664b&"
import script from "./AccountMoneyClaim.vue?vue&type=script&lang=js&"
export * from "./AccountMoneyClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports